// extracted by mini-css-extract-plugin
export default {"chatBody":"Body_chatBody__+UlBZ"};